import { z } from 'zod';
import { insuranceClaimsIdSchema } from './insurance-claims-claim.contract.js';
import { insuranceClaimsDocumentsScopeCompletionAvailabilitySchema } from './insurance-claims-documents-scope-completion.contract.js';
import { insuranceClaimsFinanceScopeBillingAvailabilitySchema } from './insurance-claims-finance-scope-billing.contract.js';
export const insuranceClaimsScopeOwnerEvidenceCapability = 'insurance-claims.scope-owner-evidence.v1';
export const insuranceClaimsScopeOwnerEvidenceItemSchema = z.strictObject({
    scopeId: insuranceClaimsIdSchema,
    scopeRevision: z.number().int().positive(),
    documents: insuranceClaimsDocumentsScopeCompletionAvailabilitySchema,
    finance: insuranceClaimsFinanceScopeBillingAvailabilitySchema,
});
export const insuranceClaimsScopeOwnerEvidenceSchema = z.strictObject({
    contractVersion: z.literal(insuranceClaimsScopeOwnerEvidenceCapability),
    claimId: insuranceClaimsIdSchema,
    projectId: insuranceClaimsIdSchema,
    items: z.array(insuranceClaimsScopeOwnerEvidenceItemSchema).max(250),
}).superRefine((value, context) => {
    const scopeIds = value.items.map(({ scopeId }) => scopeId);
    if (new Set(scopeIds).size !== scopeIds.length) {
        context.addIssue({
            code: 'custom', path: ['items'], message: 'Owner evidence must contain each scope once.',
        });
    }
    value.items.forEach((item, index) => {
        if (item.documents.state === 'present' &&
            (item.documents.claimId !== value.claimId ||
                item.documents.projectId !== value.projectId ||
                item.documents.scopeId !== item.scopeId)) {
            context.addIssue({
                code: 'custom', path: ['items', index, 'documents'],
                message: 'Documents owner evidence identity does not match the Claims scope.',
            });
        }
        if (item.finance.state === 'present' &&
            (item.finance.claimId !== value.claimId || item.finance.projectId !== value.projectId ||
                item.finance.scopeId !== item.scopeId)) {
            context.addIssue({
                code: 'custom', path: ['items', index, 'finance'],
                message: 'Finance owner evidence identity does not match the Claims scope.',
            });
        }
    });
});
export const insuranceClaimsScopeOwnerEvidenceResponseSchema = z.strictObject({
    data: insuranceClaimsScopeOwnerEvidenceSchema,
});
//# sourceMappingURL=insurance-claims-scope-owner-evidence.contract.js.map